import { InjectionToken } from '@angular/core';

import { IGoogleTagManagerConfig } from '../interfaces/i-google-tag-manager-config';

export const GOOGLE_TAG_MANAGER_CONFIG_TOKEN = new InjectionToken<IGoogleTagManagerConfig>('google-tag-manager-config', {
  factory: () => ({ trackingCode: '' })
});
